import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import knowledgeBankService from "../../services/knowledgeBankService";

const useKnowledgeBankEvent = (id) =>
    useQuery(
        [queryKeys.knowledgeBankArticle, id],
        () => knowledgeBankService.getEvent(id),
        {
            staleTime: Infinity
        }
    )

export default useKnowledgeBankEvent;
